import HttpService from "common/services/HttpServiceV2";

import CustomErrorManager from "common/services/CustomErrorManager.js";
import CustomErrorCodes from "common/enums/CustomErrorCodes.js";
import { AUTHENTICATION_TYPE } from "./enums/LiveStreamingEnums.js";

import LiveStreaming from "./LiveStreaming";

const isLocal = location.hostname === "localhost";
const BASE_URL = isLocal
  ? "https://localhost:7251/communication"
  : "/api/communication/communication";

export default class IceServersConfigService {
  static config = {
    numberOfRetryAttempts: 10
  };

  static iceConfig = {
    iceServers: [
      {
        urls: "stun:stun.l.google.com:19302"
      }
    ]
  };

  static init(config) {
    IceServersConfigService.config = { ...config };
  }

  static isIceServerCredentialsExpired = () => {
    return true;
  };

  static getIceServersConfig = async () => {
    try {
      let config = {};
      if (LiveStreaming.config.authType == AUTHENTICATION_TYPE.SDK) {
        config = await LiveStreaming.getTurnServerConfig(IceServersConfigService.config.userId);
      } else {
        const credentialsExpired = IceServersConfigService.isIceServerCredentialsExpired();

        if (credentialsExpired) {
          config = await IceServersConfigService.fetchIceServersConfig();
        }
      }

      IceServersConfigService.iceConfig.iceServers = config;
      return IceServersConfigService.iceConfig;
    } catch (error) {
      console.log(error);
      return IceServersConfigService.serverConfig;
    }
  };

  static fetchIceServersConfig = async () => {
    const url = `get-turn-server-config`;
    const headers = {
      "Content-type": "application/json"
    };
    let formData = {
      userId: IceServersConfigService.config.userId
    };

    let baseURL = LiveStreaming.config.basePath || BASE_URL;
    let res = await HttpService.postRequestWithRetry(baseURL, url, formData, headers);

    if (res && res.status == 200) {
      let statusCode = res.data.statusCode;

      if (statusCode == 0) {
        let response = res.data.responseObject;
        let configList = [];
        let username = response.username;
        let password = response.password;

        if (username != undefined && password != undefined) {
          if (response.stunServerURL) {
            let config = {
              urls: response.stunServerURL,
              username,
              credential: password
            };
            configList.push(config);
          }

          if (response.turnServerURL) {
            let config = {
              urls: response.turnServerURL,
              username,
              credential: password
            };
            configList.push(config);
          }

          if (response.turnsServerURL) {
            let config = {
              urls: response.turnsServerURL,
              username,
              credential: password
            };
            configList.push(config);
          }

          response = configList;

          return response;
        } else {
          throw CustomErrorManager.InValidError(
            CustomErrorCodes.INCORRECT_CONFIG,
            "Turn server username or password not found"
          );
        }
      } else {
        throw CustomErrorManager.ServiceError(
          CustomErrorCodes.SERVICE_INTERNAL_ERROR,
          "Failed to get turn server config due to internal server error"
        );
      }
    } else {
      console.log(`res status is not 200: `, res);
      // todo: throw correct errors here based on status code
    }
  };
}
